export const payment_methods = {
  fawry: "فوري",
  vodafone_cash: "محفظة إلكترونية",
  wallet: "محفظة",
  code: "كود",
};